module.exports = __webpack_public_path__ + "img/amex.f7f7893b.svg";